import React from 'react';

/**
 * FileRevisionHistory Component
 * Revision table displaying historical revisions, submitters, upload dates, notes, and actions.
 */
export default function FileRevisionHistory({
    file,
    onViewRevision,
    onDownloadRevision,
}) {
    if (!file || !file.revisions || !file.revisions.length) {
        return null;
    }

    return (
        <section className="p-6 bg-white dark:bg-[#141c2b]">
            <div className="flex items-center justify-between mb-4">
                <h3 className="text-lg font-bold text-[#0b1c30] dark:text-[#eaf1ff]">
                    Revision History
                </h3>
                <span className="text-xs text-[#727786] dark:text-[#9aa5bc]">
                    {file.revisions.length} historical {file.revisions.length === 1 ? 'iteration' : 'iterations'} logged
                </span>
            </div>

            <div className="border border-[#c1c6d7] dark:border-[#344258] rounded-xl overflow-hidden shadow-xs">
                <table className="w-full text-left border-collapse">
                    <thead className="bg-[#eff4ff] dark:bg-[#1a2538] border-b border-[#c1c6d7] dark:border-[#344258]">
                        <tr>
                            <th className="px-6 py-3.5 text-xs font-bold text-[#555d73] dark:text-[#9aa5bc] uppercase tracking-wider">
                                Version
                            </th>
                            <th className="px-6 py-3.5 text-xs font-bold text-[#555d73] dark:text-[#9aa5bc] uppercase tracking-wider">
                                Uploaded By
                            </th>
                            <th className="px-6 py-3.5 text-xs font-bold text-[#555d73] dark:text-[#9aa5bc] uppercase tracking-wider">
                                Upload Date
                            </th>
                            <th className="px-6 py-3.5 text-xs font-bold text-[#555d73] dark:text-[#9aa5bc] uppercase tracking-wider">
                                Revision Notes
                            </th>
                            <th className="px-6 py-3.5 text-xs font-bold text-[#555d73] dark:text-[#9aa5bc] uppercase tracking-wider text-right">
                                Actions
                            </th>
                        </tr>
                    </thead>
                    <tbody className="divide-y divide-[#c1c6d7]/60 dark:divide-[#344258]">
                        {file.revisions.map((rev, index) => {
                            const isCurrent = index === 0;

                            return (
                                <tr
                                    key={rev.version}
                                    className="hover:bg-[#eff4ff]/60 dark:hover:bg-[#212f45]/40 transition-colors"
                                >
                                    <td className="px-6 py-4">
                                        <span
                                            className={`
                                                px-3 py-1 rounded-full text-xs font-extrabold inline-block
                                                ${isCurrent
                                                    ? 'bg-[#e6f8f5] dark:bg-[#0b3d37] text-[#006f66] dark:text-[#89f5e7] border border-[#006f66]/20'
                                                    : 'bg-[#eff4ff] dark:bg-[#212f45] text-[#414754] dark:text-[#9aa5bc] border border-slate-300 dark:border-slate-700'
                                                }
                                            `}
                                        >
                                            {rev.version}
                                        </span>
                                    </td>
                                    <td className="px-6 py-4 text-sm font-semibold text-[#0b1c30] dark:text-[#eaf1ff]">
                                        {rev.uploadedBy}
                                    </td>
                                    <td className="px-6 py-4 text-sm text-[#555d73] dark:text-[#9aa5bc]">
                                        {rev.uploadDate}
                                    </td>
                                    <td className="px-6 py-4 text-sm text-[#414754] dark:text-[#eaf1ff] leading-relaxed">
                                        {rev.revisionNotes || 'No notes documented.'}
                                    </td>
                                    <td className="px-6 py-4 text-right">
                                        <div className="flex justify-end items-center gap-2">
                                            <button
                                                type="button"
                                                onClick={() => onViewRevision?.(rev)}
                                                title="View Revision"
                                                className="material-symbols-outlined text-lg text-[#727786] hover:text-[#0070F3] transition-colors p-1.5 hover:bg-slate-100 dark:hover:bg-slate-800 rounded-lg"
                                            >
                                                visibility
                                            </button>
                                            <button
                                                type="button"
                                                onClick={() => onDownloadRevision?.(rev)}
                                                title="Download Revision"
                                                className="material-symbols-outlined text-lg text-[#727786] hover:text-[#0070F3] transition-colors p-1.5 hover:bg-slate-100 dark:hover:bg-slate-800 rounded-lg"
                                            >
                                                download
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>
        </section>
    );
}
